import { atom } from "@workflows/runtime-web";
export const dcocomSupplychainIntakeFormStep = atom({
  key: "dcocomSupplychainIntakeFormState",
  default: 0
});
export const dcocomSupplychainIntakeFormMatterId = atom({
  key: "dcocomSupplychainIntakeFormMatter",
  default: ""
});
export const dcocomSupplychainIntakeFormCode = atom({
  key: "dcocomSupplychainIntakeFormCode",
  default: ""
});
export const dcocomSupplychainIntakeFormURLs = ["/supplychain/address", "/supplychain/time", "/supplychain/content", "/supplychain/submit"];